import { render, staticRenderFns } from "./NewPersonEmergencyContact.vue?vue&type=template&id=d3cecfaa&scoped=true&"
import script from "./NewPersonEmergencyContact.vue?vue&type=script&lang=js&"
export * from "./NewPersonEmergencyContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3cecfaa",
  null
  
)

export default component.exports